import { defineMessages } from 'react-intl';

export const errorPageMessages = defineMessages({
  title: {
    id: 'page.500.title',
    defaultMessage: '500 - ES IST EIN FEHLER AUFGETRETEN',
  },
  description: {
    id: 'page.500.description',
    defaultMessage: 'Leider ist hier ein Fehler aufgetreten.',
  },
  info: {
    id: 'page.500.info',
    defaultMessage: 'Doch vielleicht haben wir trotzdem etwas für dich. Besuche unsere Startseite.',
  },
  buttonLabel: {
    id: 'page.500.button.label',
    defaultMessage: 'zur Startseite',
  },
});
